import React, { useState } from "react";
import {
  NavbarContainer,
  Logo,
  MenuContainer,
  HamburgerButton,
  LogoContainer,
  ResponsiveMenuContainer,
  IconsContainer,
} from "./styled.components";
import NavbarMenu from "./menu";
import companyLogo from "../../../../assets/images/logo.png";
import { useNavigate } from "react-router-dom";

import { headerConfig } from "./headerConfig";

const Navbar = () => {
  const [showResponsiveMenu, setShowResponsiveMenu] = useState(false);
  const navigate = useNavigate();

  return (
    <NavbarContainer>
      <LogoContainer>
        <Logo src={companyLogo} onClick={() => navigate("/")} />
      </LogoContainer>
      <MenuContainer>
        {headerConfig.map((item) => (
          <NavbarMenu key={item.title} {...item} />
        ))}
          <IconsContainer>
        <svg width="20" height="20" viewBox="0 0 13 22">
          <g id="facebook" transform="translate(1 1)">
            <path
              id="facebook-2"
              data-name="facebook"
              d="M18,2H15a5,5,0,0,0-5,5v3H7v4h3v8h4V14h3l1-4H14V7a1,1,0,0,1,1-1h3Z"
              transform="translate(-7 -2)"
              fill="none"
              stroke="#ffffff"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            ></path>
          </g>
        </svg>
        <svg width="20" height="20" viewBox="0 0 24 20.141">
          <g id="twitter" transform="translate(1 1.078)">
            <path
              id="twitter-2"
              data-name="twitter"
              d="M23,3a10.9,10.9,0,0,1-3.14,1.53,4.48,4.48,0,0,0-7.86,3v1A10.66,10.66,0,0,1,3,4s-4,9,5,13a11.64,11.64,0,0,1-7,2c9,5,20,0,20-11.5a4.5,4.5,0,0,0-.08-.83A7.72,7.72,0,0,0,23,3Z"
              transform="translate(-1 -2.99)"
              fill="none"
              stroke="#ffffff"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            ></path>
          </g>
        </svg>
        <svg width="20" height="20" viewBox="0 0 22 22">
          <g id="instagram" transform="translate(1 1)">
            <rect
              id="Rectangle_2544"
              data-name="Rectangle 2544"
              width="20"
              height="20"
              rx="5"
              fill="none"
              stroke="#ffffff"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            ></rect>
            <path
              id="Path_147"
              data-name="Path 147"
              d="M16,11.37A4,4,0,1,1,12.63,8,4,4,0,0,1,16,11.37Z"
              transform="translate(-2 -2)"
              fill="none"
              stroke="#ffffff"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            ></path>
            <line
              id="Line_146"
              data-name="Line 146"
              x2="0.01"
              transform="translate(15.5 4.5)"
              fill="none"
              stroke="#ffffff"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            ></line>
          </g>
        </svg>
      </IconsContainer>
      </MenuContainer>

      <HamburgerButton
        onClick={() => setShowResponsiveMenu(!showResponsiveMenu)}
      >
        <div />
        <div />
        <div />
      </HamburgerButton>
      {showResponsiveMenu && (
        <ResponsiveMenuContainer>
          {headerConfig.map((item) => (
            <NavbarMenu key={item.title} {...item} isResponsive />
          ))}
        </ResponsiveMenuContainer>
      )}
    </NavbarContainer>
  );
};

export default Navbar;
